export const TEMPLATE_LAYERS_EXTRA_FIELDS = [];
